var _path, _line, _line2, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlarmExclamationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3507 21.6998C35.3507 29.7603 28.4652 36.3911 19.8495 36.3911C11.2338 36.3911 4.34832 29.7603 4.34832 21.6998C4.34832 13.6393 11.2338 7.00848 19.8495 7.00848C28.4652 7.00848 35.3507 13.6393 35.3507 21.6998Z",
    fill: "#3393FF",
    stroke: "#3393FF",
    strokeWidth: 2.29821
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.95349,
    y1: -1.95349,
    x2: 6.32487,
    y2: -1.95349,
    transform: "matrix(0.707132 -0.707081 0.707132 0.707081 4.86328 40.0002)",
    stroke: "#3393FF",
    strokeWidth: 3.90698,
    strokeLinecap: "square"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.95349,
    y1: -1.95349,
    x2: 6.32487,
    y2: -1.95349,
    transform: "matrix(0.707132 0.707081 -0.707132 0.707081 28.8281 33.6055)",
    stroke: "#3393FF",
    strokeWidth: 3.90698,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3267 11.7261L27.2266 2.92589C27.2266 2.92589 33.6648 0.768484 36.4767 2.92589C39.3443 5.12601 38.3267 11.7261 38.3267 11.7261Z",
    fill: "#3393FF",
    stroke: "#3393FF",
    strokeWidth: 1.1491,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2814 2.68695L1.47352 10.6097C1.47352 10.6097 0.949426 4.13501 3.86764 2.10936C6.84364 0.043597 13.2814 2.68695 13.2814 2.68695Z",
    fill: "#3393FF",
    stroke: "#3393FF",
    strokeWidth: 1.1491,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5748 13.654C21.5748 14.1136 21.5656 14.7296 21.5473 15.5018C21.5289 16.2556 21.4921 17.0921 21.4369 18.0114C21.4002 18.9307 21.345 19.8408 21.2715 20.7417C21.1979 21.6242 21.106 22.4239 20.9957 23.141C20.867 23.2513 20.6372 23.3432 20.3062 23.4168C19.9753 23.4719 19.6903 23.4995 19.4513 23.4995C19.01 23.4995 18.6239 23.426 18.293 23.2789C17.9804 23.1134 17.7874 22.8284 17.7139 22.4239C17.6403 21.9643 17.5668 21.33 17.4932 20.521C17.4381 19.6937 17.3829 18.7836 17.3278 17.7908C17.291 16.7979 17.2634 15.8235 17.245 14.8674C17.2266 13.9114 17.2174 13.0748 17.2174 12.3578C17.8977 11.9533 18.6699 11.7511 19.534 11.7511C20.1775 11.7511 20.6739 11.9074 21.0233 12.2199C21.391 12.5325 21.5748 13.0105 21.5748 13.654ZM17.0796 27.3053C17.0796 26.6435 17.291 26.0919 17.7139 25.6506C18.1551 25.2094 18.7435 24.9887 19.4789 24.9887C20.1959 24.9887 20.7659 25.2094 21.1887 25.6506C21.63 26.0919 21.8506 26.6435 21.8506 27.3053C21.8506 27.9856 21.63 28.5464 21.1887 28.9876C20.7659 29.4289 20.1959 29.6495 19.4789 29.6495C18.7435 29.6495 18.1551 29.4289 17.7139 28.9876C17.291 28.5464 17.0796 27.9856 17.0796 27.3053Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmExclamationIcon);
export default __webpack_public_path__ + "static/media/alarm-exclamation-icon.9db521b94c97f56eacd20ca5042bda43.svg";
export { ForwardRef as ReactComponent };